import { render } from "./businessType.vue?vue&type=template&id=72a7bc74&scoped=true"
import script from "./businessType.vue?vue&type=script&lang=js"
export * from "./businessType.vue?vue&type=script&lang=js"

import "./businessType.vue?vue&type=style&index=0&id=72a7bc74&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a7bc74"]])

export default __exports__